import { sendClickHouseAnalytic } from '@shared/api/analytics/template'
import { PickAnalytic } from '@shared/api/analytics/types/types'

export const EGGGigAss = {
  /**
   * Нажатие на кнопку ассистента
   */
  assistant_button_click: () =>
    sendClickHouseAnalytic({
      section_name: 'gigachat',
      event_name: 'element_click',
      element_type: 'gigachat_start',
    }),

  /**
   * Блок отобразился на экране
   */
  page_shown: () =>
    sendClickHouseAnalytic({
      section_name: 'gigachat',
      event_name: 'screen_appear',
    }),

  /**
   * Нажатие на кнопку "Сбросить чат"
   */
  reset_chat: () =>
    sendClickHouseAnalytic({
      section_name: 'gigachat',
      event_name: 'element_click',
      element_type: 'reset_gigachat',
    }),

  /**
   * Пользователь закрыл блок с ассистентом
   */
  close_assistant: () =>
    sendClickHouseAnalytic({
      section_name: 'gigachat',
      event_name: 'element_click',
      element_type: 'gigachat_close',
    }),

  /**
   * Пользователь закрыл блок с ассистентом нажатием на пустое поле
   */
  close_assistant_outside: () =>
    sendClickHouseAnalytic({
      section_name: 'gigachat',
      event_name: 'element_click',
      element_type: 'gigachat_outside',
    }),

  /**
   * Пользователь воспользовался подсказкой
   * @param props - Параметры с названием кнопки на экране
   */
  help_click: (props: PickAnalytic<'page_active_tab'>) =>
    sendClickHouseAnalytic({
      ...props,
      section_name: 'gigachat',
      event_name: 'element_click',
      element_type: 'gigachat_help',
    }),

  /**
   * Пользователь отправил запрос
   */
  send_request: () =>
    sendClickHouseAnalytic({
      section_name: 'gigachat',
      event_name: 'type_text',
      element_type: 'gigachat_ask',
    }),
}
